export default __webpack_public_path__ + "static/media/login-title-mobile.054e5856.webp";